import { InjectionToken } from '@angular/core';

export interface CognitoConfig {
  readonly userPoolId: string;
  readonly userPoolClientId: string;
}

export interface RuntimeConfig {
  readonly envName: string;
  readonly apiUrl: string;
  readonly region: string;
  readonly cognito: CognitoConfig;
}

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG');

function isRuntimeConfig(value: unknown): value is RuntimeConfig {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const candidate = value as Partial<RuntimeConfig>;
  return (
    typeof candidate.apiUrl === 'string' &&
    typeof candidate.region === 'string' &&
    typeof candidate.cognito?.userPoolId === 'string' &&
    typeof candidate.cognito?.userPoolClientId === 'string'
  );
}

/**
 * Charge la configuration avant le démarrage de l'application.
 *
 * Le fichier `config.json` est déposé sur S3 par le déploiement CDK, ce qui
 * permet de promouvoir le même bundle Angular d'un environnement à l'autre
 * sans le reconstruire.
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch('config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Configuration introuvable (HTTP ${response.status}).`);
  }

  const parsed: unknown = await response.json();
  if (!isRuntimeConfig(parsed)) {
    throw new Error('Le fichier config.json est incomplet ou malformé.');
  }
  return parsed;
}
